import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {getPaykuBanks, postPaykuWithdrawal} from "../../services/wallet/payku.service";

export const usePostPaykuWithdrawal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postPaykuWithdrawal,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ["userWallet"]});
    },
    onError: _error => {},
  });
};

export const useGetPaykuBanks = currency => {
  return useQuery({
    queryKey: ["paykuBanks", currency],
    queryFn: () => getPaykuBanks(currency),
    // The wallet API wraps payloads as { status, message, data, httpCode },
    // and axios wraps that again as { data: <body>, status }. Flatten both
    // layers here so consumers always see a plain array (or [] on errors)
    // and never end up calling .map on an object.
    select: response => response?.data?.data ?? [],
    enabled: !!currency,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
